import {
  AbilityBuilder,
  AbilityClass,
  ConditionsMatcher,
  mongoQueryMatcher,
  PureAbility
} from '@casl/ability';

import { Action, AppAbility, UserForAbility } from '../types/Permission';

export type { AppAbility, UserForAbility } from '../types/Permission';

export function createUserAbility(
  user: UserForAbility,
  rules?: AppAbility['_indexedRules']
) {
  const { can, build, cannot } = new AbilityBuilder(
    PureAbility as AbilityClass<AppAbility>
  );

  const target = user?.proxiedAs || user;
  const isGlobalAdmin = target?.isGlobalAdmin;
  const isEligible = target?.isEligible;

  if (isEligible) {
    can(Action.View, 'Home');
  } else {
    cannot(Action.View, 'CommonMenus');
  }

  if (isGlobalAdmin) {
    can(Action.View, 'Administration');
    can(Action.Proxy, 'User');
    can(Action.Manage, 'Employee');
  }

  if (user?.proxiedAs && !user.proxiedAs.isGlobalAdmin) {
    can(Action.StopProxy, 'User');
  }

  const ability = build({
    conditionsMatcher: mongoQueryMatcher as ConditionsMatcher<unknown>
  });

  if (rules) {
    ability.update(rules);
  }

  return ability;
}
